import React from 'react';
import { connect } from 'react-redux';
import './BuyOnChatFloating.scss';
import { passUtmData } from '../../../../actionCreators/common';
import { getUserEventData } from '../../../../utils/helper';
import { whatsappCapturePhoneNumber } from '../../../../actionCreators/phoneNumberCapture';

function buyOnChatOnClick(triggerDtmOnClick, passUtmData, whatsappCapturePhoneNumber) {
  if (triggerDtmOnClick) {
    triggerDtmOnClick();
  }
  const data = getUserEventData('BUY_ON_CHAT');
  passUtmData(data);
  whatsappCapturePhoneNumber();
  if (typeof window.clevertap !== 'undefined') {
    window.clevertap.event.push('Page Visited', {
      pageName: 'Chat with Expert Page',
    });
  }
}

function ShowFloatingWidget(props) {
  const {
    triggerDtmOnClick,
    dataLocale: { WHATSAPP_CHAT_URL, CHAT, BUYONCHAT_CAT_PLP },
    buyWithCallConfig,
    pageName,
    passUtmData,
    whatsappCapturePhoneNumber,
    redisCommonData,
  } = props;
  const { SHOW_BUY_ON_CHAT } = redisCommonData;
  const { enable_new_flow } = buyWithCallConfig;
  const buyOnChatDetails = SHOW_BUY_ON_CHAT ? JSON.parse(SHOW_BUY_ON_CHAT) : {};
  const whatsAppChatMsg =
    WHATSAPP_CHAT_URL &&
    buyOnChatDetails &&
    `${WHATSAPP_CHAT_URL}${BUYONCHAT_CAT_PLP}`
      .replace('<phoneNumber>', buyOnChatDetails.number)
      .replace('<pageName>', pageName);
  return (
    <div
      className={`whatsapp-widget pos-fix ${enable_new_flow ? 'new-flow' : ''}`}
      onClick={() => buyOnChatOnClick(triggerDtmOnClick, passUtmData, whatsappCapturePhoneNumber)}
    >
      <a href={whatsAppChatMsg}>
        <img
          alt={CHAT}
          src={enable_new_flow ? buyWithCallConfig.icon : buyWithCallConfig.floating_image}
        />
      </a>
    </div>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    passUtmData: data => dispatch(passUtmData(data)),
    whatsappCapturePhoneNumber: () => dispatch(whatsappCapturePhoneNumber()),
  };
};

export default connect(null, mapDispatchToProps)(ShowFloatingWidget);
